import { ViewModel,View, ObservableArray } from "binder"
import  { DeliveryCartableReportView } from "./deliveryCartableReport-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";

export class DeliveryCartableReportViewModel extends WindowViewModel{
    public getTitle(): string {
        return "گزارش کارتابل تحویل";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.factorBoxes = ObservableArray.create<SingleFactorBox>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshFactors(filteringInformation));
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DeliveryCartableReportView();
    }
    public getTypeId(): string {
        return "VM-1EAC061E-65A3-403A-9CDC-839C02BF8412"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set factorBoxes(v: ObservableArray<SingleFactorBox>) { this._factorBoxes = v; } public get factorBoxes(): ObservableArray<SingleFactorBox> { return this._factorBoxes;} private _factorBoxes: ObservableArray<SingleFactorBox>;
    private _lastTimer;
    override requestClose():boolean|Promise<boolean>{
        if(this._lastTimer!=null){
            clearTimeout(this._lastTimer);
        }
        return super.requestClose();
    }
    async refresh(){
        await this.loader.refresh();
    }

    async refreshFactors(filteringInformation:any):Promise<PaginationInfo>{
        if(this._lastTimer!=null){
            clearTimeout(this._lastTimer);
        }
        this._lastTimer = setTimeout(()=>this.refresh(),20000)
        try {
            this.isLoading = true;
            let serverResult = await ServerConnection.callServer("/Complex/ReportServices/DeliveryCartableReport",{});
            this.factorBoxes.update(...serverResult.DeliveryStatues.map(item => {
                let singleFactorBox:SingleFactorBox = new SingleFactorBox(this);
                singleFactorBox.factorNo = item.FactorNo;
                singleFactorBox.warehouseName = item.WarehouseName;
                singleFactorBox.totalLineItem = item.TotalLineItem;
                item.Status == 1 ? singleFactorBox.isNew = true 
                : item.Status == 2 ? singleFactorBox.isChanged = true
                : item.Status == 3 ? singleFactorBox.isReadyToDeliver = true 
                : " ";
                singleFactorBox.hasDangerIcon = item.IsEdited;
                singleFactorBox.hasAttachmentIcon = item.FactorPartCount > 1 ? true : false;
                return singleFactorBox;
            }));
            return new PaginationInfo(0,0);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

}

export class SingleFactorBox extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DeliveryCartableReportViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    
    public set factorNo(v: string) { this._factorNo = v; } public get factorNo(): string { return this._factorNo;} private _factorNo: string;
    public set warehouseName(v: string) { this._warehouseName = v; } public get warehouseName(): string { return this._warehouseName;} private _warehouseName: string;
    public set totalLineItem(v: number) { this._totalLineItem = v; } public get totalLineItem(): number { return this._totalLineItem;} private _totalLineItem: number;
    public set isNew(v: boolean) { this._isNew = v; } public get isNew(): boolean { return this._isNew;} private _isNew: boolean;
    public set isChanged(v: boolean) { this._isChanged = v; } public get isChanged(): boolean { return this._isChanged;} private _isChanged: boolean;
    public set isReadyToDeliver(v: boolean) { this._isReadyToDeliver = v; } public get isReadyToDeliver(): boolean { return this._isReadyToDeliver;} private _isReadyToDeliver: boolean;
    public set hasAttachmentIcon(v: boolean) { this._hasAttachmentIcon = v; } public get hasAttachmentIcon(): boolean { return this._hasAttachmentIcon;} private _hasAttachmentIcon: boolean;
    public set hasDangerIcon(v: boolean) { this._hasDangerIcon = v; } public get hasDangerIcon(): boolean { return this._hasDangerIcon;} private _hasDangerIcon: boolean;
    private _typedParent;
}
